// @flow
export default {
  path: '/politica-privacidade',
  name: 'politica',
  component: () => import('modules/privacyPolicy/Index.vue'),
  meta: {
    notAuth: true,
    breadcrumbs: [
      {
        text: 'Página Inicial',
        name: 'Login'
      }
    ]
  }
};
